<main>
    <div class="container">
        <div class="row">
            <div class="col-sm-6 col-md-9">
                <div _ngcontent-cvh-c14="" class="component-title mb-3">
                    DEPÓSITOS POR BOLETO
                </div>
                <p>Visualize e crie novos depósitos por boleto</p>
            </div>
        </div>

        <div class="separador-2"></div>


    </div>

    <div class="container">
        <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 my-3">
                <form>
                    <div class="form-group">
                        <label for="inValor">Valor</label>
                        <span class="span-description">Digite o valor que você pretende depositar na sua cedente</span>
                        <input [textMask]="{mask: MASKS.currency.textMask}"
                            type="text" class="form-control" id="inValor" #inValor>
                    </div>

                    <span class="legend" *ngIf="message != ''">
                        {{ message }}
                    </span>

                    <button type="button" class="btn btn-outline-primary"
                        (click)="DepositarViaBoleto(inValor.value)">Gerar Boleto</button>
                </form>
            </div>
        </div>
    </div>




    <div class="container">
        <div class="row mt-5">

            <h5>Histórico :</h5>

            <div class="col-12">
                <div class="table-responsive">
                    <table class="table table-bordered table-striped" id="dataTable" width="100%" cellspacing="0"
                        *ngIf="true">
                        <thead class="list-table-head b-t-custom">
                            <tr>
                                <th (click)="sortOrder = !sortOrder; orderBy('solicitacaoId', sortOrder)">Código</th>
                                <th (click)="sortOrder = !sortOrder; orderBy('descricao', sortOrder)">Tipo</th>
                                <th (click)="sortOrder = !sortOrder; orderBy('situacao', sortOrder)">Status</th>
                                <th (click)="sortOrder = !sortOrder; orderBy('valor', sortOrder)">Valor</th>
                                <th (click)="sortOrder = !sortOrder; orderBy('dataCadastro', sortOrder)">Data</th>
                                <th>Ações</th>
                            </tr>
                        </thead>
                        <tbody class="list-table-row">
                            <tr *ngFor=" let solicitacao of solicitacoes" class=" list-table-cell">
                                <td>{{ solicitacao.solicitacaoId }}</td>
                                <td>{{ solicitacao.descricao }}</td>
                                <td>{{ solicitacao.situacao }}</td>
                                <td>{{ solicitacao.valor | currency:'BRL':true }}</td>
                                <td>{{ solicitacao.dataCadastro | date: 'dd/MM/yyyy' }}</td>
                                <td>
                                    <div ngbDropdown class="d-inline-block
                                        menu-option" placement="left">
                                        <button class="dropdown-button" id="dropdown-menu" ngbDropdownToggle>
                                            <img src="assets/icons/menu.png" />
                                        </button>
                                        <div *ngIf="solicitacao.situacao == 'Aguardar Pagamento'" ngbDropdownMenu
                                            aria-labelledby="dropdown-menu" class="p-0 m-0">
                                            <section class="custom-context-menu">
                                                <div ngbDropdownItem (click)="openBoleto(solicitacao.boleto)">
                                                    <img src="assets/icons/bill.png" class="mr-2" /> Segunda via
                                                </div>
                                                <div ngbDropdownItem
                                                    (click)="CancelarDeposito(solicitacao.solicitacaoId)">
                                                    <img src="assets/icons/close.png" class="mr-2" /> Cancelar
                                                </div>
                                            </section>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div *ngIf="!solicitacoes || solicitacoes?.length == 0" class="text-center">
                        <h6>
                            Nenhuma intenção de depósito encontrada
                        </h6>
                    </div>
                </div>
            </div>
        </div>
    </div>

</main>
